<template>
  <v-btn v-if="isSet" text icon x-small>
    <v-icon>mdi-check</v-icon>
  </v-btn>
</template>

<script>
export default {
  name:'BooleanColumn',
  props: {
    isSet: {
      type: Boolean,
      default: false
    }
  }

}
</script>
